import Accordion from '@/scripts/optional/accordion'

export default class Footer {
	private scrollListener: ((event: Event) => void) | null = null

	constructor() {
		this.handleAccordionMenu()
		// this.handleTextAnimation()
		//
		// window.addEventListener('resize', () => {
		// 	this.handleTextAnimation()
		// });
	}

	handleAccordionMenu() {
		if (window.innerWidth < 990) {
			new Accordion({
				el: '.footer-mob-links',
				trigger: '.accordion-el__head',
				showOne: true,
				firstOpen: true,
			})
		}
	}

	handleTextAnimation() {
		const footer = document.querySelector('.footer') as HTMLElement
		const wrapper = document.querySelector('.footer__top') as HTMLElement
		const text = wrapper?.querySelector('.footer__text') as HTMLElement

		text.style.transform = ''

		if (!wrapper || !text) return

		if (this.scrollListener) {
			window.removeEventListener('scroll', this.scrollListener)
		}

		const style = window.getComputedStyle(wrapper)
		const paddingTop = parseFloat(style.paddingTop)
		const paddingBottom = parseFloat(style.paddingBottom)

		const wrapperHeight = wrapper.offsetHeight
		const textHeight = text.offsetHeight
		
		const OFFSET_Y = -(
			text.getBoundingClientRect().top -
			(wrapper.getBoundingClientRect().top + paddingTop)
		)
		
		// Calculate center position instead of bottom
		const availableHeight = wrapperHeight - paddingTop - paddingBottom
		const containerCenterY = paddingTop + availableHeight / 2
		const textNaturalTop = text.getBoundingClientRect().top - wrapper.getBoundingClientRect().top
		const textCenterY = containerCenterY - textHeight / 2
		const centerTranslateY = textCenterY - textNaturalTop
		const maxY = centerTranslateY - OFFSET_Y
		const meltingPoint = 2.3

		text.style.transformOrigin = 'top top'
		// text.style.willChange = 'transform'
		text.style.transform = `translateY(${OFFSET_Y}px) scaleY(1)`

		let lastScroll = window.scrollY || window.pageYOffset
		let scaleY = 1
		let meltingInProgress = false
		let meltingFinished = false
		let translateYAtBottom = false

		function clamp(num: number, min: number, max: number) {
			return Math.min(Math.max(num, min), max)
		}

		function easeOutPower2(t: number) {
			return 1 - Math.pow(1 - t, 2)
		}

		function updateAnimation() {
			const scrollTop = window.scrollY || window.pageYOffset

			const start = wrapper.offsetTop - window.innerHeight * 0.8
			let end: number
			let meltingEnd: number
			if (window.innerWidth >= 1024) {
				end =
					footer.offsetTop + footer.offsetHeight - window.innerHeight
				meltingEnd = end - 5
			} else {
				end = wrapper.offsetTop - window.innerHeight * 0.6
				meltingEnd = end - 5
			}

			const progress = clamp((scrollTop - start) / (end - start), 0, 1)
			const meltingProgress = clamp((scrollTop - start) / (meltingEnd - start), 0, 1)
			const direction = scrollTop > lastScroll ? 1 : -1
			lastScroll = scrollTop

			// Reset everything if scroll above start
			if (scrollTop < start) {
				scaleY = 1
				meltingInProgress = false
				meltingFinished = false
				translateYAtBottom = false
				text.style.transform = `translateY(${OFFSET_Y}px) scaleY(1)`
				return
			}

			// SCROLL DOWN
			if (direction === 1) {
				if (!meltingFinished) {
					// Animate scaleY if melting not finished
					meltingInProgress = true
					const easedProgress = easeOutPower2(meltingProgress)
					scaleY = clamp(
						1 + (meltingPoint - 1) * easedProgress,
						1,
						meltingPoint
					)

					if (scaleY >= meltingPoint) {
						scaleY = meltingPoint
						meltingInProgress = false
						meltingFinished = true

						// Snap to center
						text.style.transition =
							'transform 0.25s cubic-bezier(0.68,-0.55,0.27,1.55)'
						text.style.transform = `translateY(${OFFSET_Y + maxY}px) scaleY(1)`
						setTimeout(() => (text.style.transition = ''), 250)
						translateYAtBottom = true
						return
					}

					// Animate scaleY only, Y fixed
					text.style.transform = `translateY(${OFFSET_Y}px) scaleY(${scaleY})`
				} else if (translateYAtBottom) {
					// If user scrolled up fully and now scrolls down, move Y down
					const y = OFFSET_Y + maxY * progress
					text.style.transform = `translateY(${y}px) scaleY(1)`
				}
			} else {
				// SCROLL UP
				if (meltingInProgress) {
					// Reverse scaleY while melting
					const easedProgress = easeOutPower2(meltingProgress)
					scaleY = clamp(
						1 + (meltingPoint - 1) * easedProgress,
						1,
						meltingPoint
					)
					text.style.transform = `translateY(${OFFSET_Y}px) scaleY(${scaleY})`
				} else if (meltingFinished) {
					// Only move Y
					const y = OFFSET_Y + maxY * progress
					text.style.transform = `translateY(${y}px) scaleY(1)`

					// Track if Y returned to OFFSET_Y to allow downward movement again
					if (y <= OFFSET_Y + 0.5) {
						translateYAtBottom = false
						meltingFinished = false // Reset melting for next scroll down
					}
				}
			}
		}

		window.addEventListener('scroll', updateAnimation)

		this.scrollListener = updateAnimation

		updateAnimation()
	}
}
